import { render, staticRenderFns } from "./GSheetCard.vue?vue&type=template&id=be5784ae&"
import script from "./GSheetCard.vue?vue&type=script&lang=js&"
export * from "./GSheetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be5784ae')) {
      api.createRecord('be5784ae', component.options)
    } else {
      api.reload('be5784ae', component.options)
    }
    module.hot.accept("./GSheetCard.vue?vue&type=template&id=be5784ae&", function () {
      api.rerender('be5784ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/GSheetCard.vue"
export default component.exports